import {UnloginFooterComponent} from "@components/unlogin-footer/unlogin-footer.component";

import {CUSTOM_ELEMENTS_SCHEMA, NgModule} from '@angular/core';
// import { CommonModule } from '@angular/common';
//
//
// import {NgModule} from "@angular/core";
import {CommonModule} from '@angular/common';

import {IonicModule} from '@ionic/angular';

@NgModule({
  imports: [
    CommonModule,
    IonicModule,
  ],
  exports: [
    UnloginFooterComponent
  ],
  declarations: [UnloginFooterComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})

// @NgModule({
//   declarations: [UnloginFooterComponent],
//   exports: [UnloginFooterComponent],  // Make sure it's exported!
//   schemas: [CUSTOM_ELEMENTS_SCHEMA],
//   imports: [CommonModule]
// })
export class SharedModule {}
